import { AnimatePresence } from 'framer-motion';
import React from 'react';
import { NODE_ID_KEYS } from '@/constants';
import { MenuButton } from '../../MenuButton';
import { Center } from '../Center';
import { type IProps } from '../Header';
import { Left } from '../Left';
import styles from './Body.module.scss';

interface IBodyProps extends IProps {
	updateHeader?: (isShown: boolean) => void;
}

export const Body = ({
	title,
	action,
	showMenuButton,
	showCenterLogo,
	classes,
	updateHeader,
}: IBodyProps) => {
	const { body } = classes ?? {};
	const { goBackCallback, icon } = action ?? {};

	return (
		<div
			className={`
				${styles['body']}
				${body ?? ''}
			`}
		>
			<div className={styles['body__wrapper']}>
				<AnimatePresence initial={false} mode='popLayout'>
					<Left key={icon} icon={icon} goBackCallback={goBackCallback} />
				</AnimatePresence>
			</div>
			<div
				className={`
					${styles['body__wrapper']}
					${styles['body__wrapper_center']}
				`}
			>
				<AnimatePresence initial={false} mode='popLayout'>
					<Center
						key={`${title}-${showCenterLogo}`}
						showCenterLogo={showCenterLogo}
						title={title}
					/>
				</AnimatePresence>
			</div>

			<div className={styles['body__wrapper']}>
				<div className={styles['body__menu-button']}>
					<AnimatePresence initial={false} mode='popLayout'>
						{showMenuButton ? (
							<MenuButton
								updateHeader={updateHeader}
								headerElementId={NODE_ID_KEYS.HEADER}
							/>
						) : null}
					</AnimatePresence>
				</div>
			</div>
		</div>
	);
};
